import { useOrderGetList } from 'api/requests';
import { useQueryListData } from 'hooks';
import { generatePath, ROUTES } from 'libs/navigation';
import { TableSetRowHref } from 'libs/ui';

import { OrdersListItem } from '../types';

const LIMIT = 50;

export const useOrders = () => {
  const {
    list: orders,
    rowCount,
    loading,
    setFilter,
    sort,
    page,
    filter,
    onPaginationChange,
    onSortChange,
  } = useQueryListData(useOrderGetList, {
    limit: LIMIT,
    filterParams: ['search'],
    filterParsers: {
      search: (value) => value,
    },
  });

  const setRowHref: TableSetRowHref<OrdersListItem> = (order) =>
    generatePath(ROUTES.orders.order.fullPath, {
      orderId: order.id,
    });

  // GMT+5 (Алматы)
  // TODO: Feature request to get broker timezone offset from API
  const brokerTimezoneOffset = 18000;

  return {
    orders,
    rowCount,
    loading: loading && !orders.length,
    sort,
    page,
    filter,
    limit: LIMIT,
    brokerTimezoneOffset,
    setRowHref,
    setFilter,
    onPaginationChange,
    onSortChange,
  };
};
